import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCheckoutState } from '../../../utils/checkoutState';
import { config } from '../../../utils/config';
import Button from '../../atoms/Button';
import MainHeadline from '../../atoms/MainHeadline';
import Select from '../../atoms/Select';
import SubHeadline from '../../atoms/SubHeadline';
import RuleEngineTable from './RuleEngineTable';
import './style.scss';

const FRONT_END = 'FE';
const BACK_END = 'BE';

const DebugPanelContent = ({ onClose }: { onClose: () => void }) => {
  const { checkoutState } = useCheckoutState();
  const { formatMessage } = useIntl();
  const { debug } = checkoutState;

  const [selectedRuleStatus, setSelectedRuleStatus] = useState('both');
  const [searchTerm, setSearchTerm] = useState('');

  const ruleStatuses = ['matched', 'notMatched', 'both'];
  const options = ruleStatuses.map(value => ({
    value,
    label: formatMessage({ id: `debug.ruleStatus.${value}` })
  }));

  const filteredRules = debug?.ruleEngine?.filter(ruleEngine => {
    const { isMatched, key = '', option = '', action = '', definition = '' } = ruleEngine || {};

    const searchTermFound =
      key.toLowerCase().includes(searchTerm.toLowerCase()) ||
      option.toLowerCase().includes(searchTerm.toLowerCase()) ||
      action.toLowerCase().includes(searchTerm.toLowerCase()) ||
      definition.toLowerCase().includes(searchTerm.toLowerCase());

    if (selectedRuleStatus === 'both') {
      return searchTermFound;
    }
    if (selectedRuleStatus === 'matched') {
      return isMatched && searchTermFound;
    }
    if (selectedRuleStatus === 'notMatched') {
      return !isMatched && searchTermFound;
    }

    return false;
  });

  return (
    <>
      <div className="debug__panel-header">
        <MainHeadline>
          <FormattedMessage id="debug.ruleEngine" />
          <span className="debug__release-version">{`${FRONT_END}: ${RELEASE_ID}`}</span>
          <span className="debug__release-version">{`${BACK_END}: ${config.version}`}</span>
          <span className="debug__release-version">{`ENV: ${config.environment}`}</span>
        </MainHeadline>
        <div className="debug__rule-status-container">
          <div className="float float__input">
            <input
              id="rule-engine__search"
              name="rule-engine__search"
              className="input"
              placeholder={formatMessage({ id: 'generic.search' })}
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
            <label htmlFor="rule-engine__search" className="label">
              <FormattedMessage id="generic.search" />
            </label>
          </div>
          <Select
            className="debug__rule-status-container--filter"
            name="rule-status"
            value={selectedRuleStatus}
            data-test-id="debug-panel-filter-rule-status"
            options={options}
            onChange={setSelectedRuleStatus}
          />
        </div>
      </div>
      <div className="debug__content-container">
        {debug!.ruleEngine?.length ?
          <RuleEngineTable ruleEngine={filteredRules!} orderId={checkoutState.orderState.id!} searchTerm={searchTerm} />
        : <SubHeadline className="debug__empty-content-container">
            <FormattedMessage id="generic.noData" />
          </SubHeadline>
        }
      </div>
      <div className="debug__action-buttons">
        <Button type="button" onClick={() => onClose()} data-test-id="debug-panel-close-button">
          <FormattedMessage id="generic.close" />
        </Button>
      </div>
    </>
  );
};

export default DebugPanelContent;
